module.exports = __webpack_public_path__ + "img/cover-slot-bg.7f9532a5.png";